import { useRef, useState } from 'react';

export const AGE_SESSION_KEY = 'age_verified_for_tickets';

const useAgeVerification = () => {
  const [showAgePopup, setShowAgePopup] = useState(false);
  const pendingActionRef = useRef(null);

  const requireAgeVerification = (action) => {
    if (typeof action !== 'function') {
      return;
    }

    if (sessionStorage.getItem(AGE_SESSION_KEY) === 'true') {
      action();
      return;
    }

    pendingActionRef.current = action;
    setShowAgePopup(true);
  };

  const confirmAge = () => {
    sessionStorage.setItem(AGE_SESSION_KEY, 'true');
    setShowAgePopup(false);
    const action = pendingActionRef.current;
    pendingActionRef.current = null;

    if (action) {
      action();
    }
  };

  const closeAgePopup = () => {
    pendingActionRef.current = null;
    setShowAgePopup(false);
  };

  return {
    showAgePopup,
    requireAgeVerification,
    confirmAge,
    closeAgePopup,
  };
};

export default useAgeVerification;
